import { call } from "redux-saga/effects";

import { Api } from "@/utils";

/**
 * Triggers a Distech sync by re-putting the floor space without modifications.
 *
 * @param floorSpaceId - The ID of the floor space to sync.
 * @returns The API sync response.
 * @yields Calls the API to trigger a floor space sync.
 */
function* syncFloorSpace(floorSpaceId) {
    try {
        // Trigger a Distech notification to sync with controller by putting the floor space without modifications
        const result = yield call(Api.get, `v1/floor-spaces/${floorSpaceId}`);
        return yield call(Api.put, "v1/floor-spaces/", [result]);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.log("error syncing floor space: ", error);
        return [];
    }
}

export default syncFloorSpace;
